module.exports = __webpack_public_path__ + "img/ps.85b72e91.png";